var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageQuestionCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message-question-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7.87399 6.75168C8.00613 6.37602 8.26697 6.05925 8.61029 5.85748C8.95361 5.65571 9.35726 5.58195 9.74975 5.64928C10.1422 5.7166 10.4982 5.92065 10.7547 6.2253C11.0111 6.52995 11.1515 6.91554 11.1509 7.31376C11.1509 8.43792 9.46467 9 9.46467 9M9.48641 11.25H9.49391M9.37399 15C12.8948 15 15.749 12.1458 15.749 8.625C15.749 5.10418 12.8948 2.25 9.37399 2.25C5.85317 2.25 2.99899 5.10418 2.99899 8.625C2.99899 9.3375 3.11587 10.0227 3.33151 10.6625C3.41266 10.9032 3.45324 11.0236 3.46056 11.1161C3.46778 11.2074 3.46232 11.2714 3.43973 11.3602C3.41685 11.4501 3.36633 11.5436 3.26531 11.7306L2.03856 14.0013C1.86358 14.3252 1.77609 14.4871 1.79567 14.6121C1.81273 14.7209 1.8768 14.8168 1.97087 14.8742C2.07887 14.9401 2.26196 14.9211 2.62814 14.8833L6.46891 14.4863C6.58522 14.4742 6.64337 14.4682 6.69638 14.4703C6.74852 14.4722 6.78532 14.4771 6.83616 14.4889C6.88785 14.5008 6.95285 14.5258 7.08285 14.5759C7.79389 14.8498 8.5664 15 9.37399 15Z",
    stroke: "#A273FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageQuestionCircle);
export default __webpack_public_path__ + "static/media/message-question-circle.c61143206a110462de17d0a5eb39af94.svg";
export { ForwardRef as ReactComponent };